import React from "react"

import { Global, css } from "@emotion/react"

import DMSansBold from "../assets/fonts/DMSans/DMSans-Bold.ttf"
import DMSansMedium from "../assets/fonts/DMSans/DMSans-Medium.ttf"
import DMSans from "../assets/fonts/DMSans/DMSans-Regular.ttf"
import PPMoriBold3 from "../assets/fonts/PPMori/ttf/PPMori-Bold.ttf"
import PPMoriLight3 from "../assets/fonts/PPMori/ttf/PPMori-Light.ttf"
import PPMoriMedium3 from "../assets/fonts/PPMori/ttf/PPMori-Medium.ttf"
import PPMori3 from "../assets/fonts/PPMori/ttf/PPMori-Regular.ttf"
import PPMoriSemibold3 from "../assets/fonts/PPMori/ttf/PPMori-SemiBold.ttf"
import PPMoriBold from "../assets/fonts/PPMori/woff2/PPMori-Bold.woff2"
import PPMoriLight from "../assets/fonts/PPMori/woff2/PPMori-Light.woff2"
import PPMoriMedium from "../assets/fonts/PPMori/woff2/PPMori-Medium.woff2"
import PPMori from "../assets/fonts/PPMori/woff2/PPMori-Regular.woff2"
import PPMoriSemibold from "../assets/fonts/PPMori/woff2/PPMori-SemiBold.woff2"
import PPMoriBold2 from "../assets/fonts/PPMori/woff/PPMori-Bold.woff"
import PPMoriLight2 from "../assets/fonts/PPMori/woff/PPMori-Light.woff"
import PPMoriMedium2 from "../assets/fonts/PPMori/woff/PPMori-Medium.woff"
import PPMori2 from "../assets/fonts/PPMori/woff/PPMori-Regular.woff"
import PPMoriSemibold2 from "../assets/fonts/PPMori/woff/PPMori-SemiBold.woff"

// https://css-tricks.com/snippets/css/using-font-face-in-css/
export const NirvanaFontsElement: React.FunctionComponent = () => {
    return (
        <Global
            styles={css([
                // PP MORI
                {
                    "@font-face": {
                        fontFamily: "PPMoriLight",
                        fontStyle: "normal",
                        fontWeight: "normal",
                        src: `local('PPMoriLight'),
                            url(${PPMoriLight}) format('woff2'), /* Super Modern Browsers */
                            url(${PPMoriLight2}) format('woff'), /* Pretty Modern Browsers */
                            url(${PPMoriLight3}) format('truetype'); /* Safari, Android, iOS */`,
                    },
                },
                {
                    "@font-face": {
                        fontFamily: "PPMori",
                        fontStyle: "normal",
                        fontWeight: "normal",
                        src: `local('PPMori'),
                            url(${PPMori}) format('woff2'), /* Super Modern Browsers */
                            url(${PPMori2}) format('woff'), /* Pretty Modern Browsers */
                            url(${PPMori3}) format('truetype'); /* Safari, Android, iOS */`,
                    },
                },
                {
                    "@font-face": {
                        fontFamily: "PPMoriMedium",
                        fontStyle: "normal",
                        fontWeight: "normal",
                        src: `local('PPMoriMedium'),
                            url(${PPMoriMedium}) format('woff2'), /* Super Modern Browsers */
                            url(${PPMoriMedium2}) format('woff'), /* Pretty Modern Browsers */
                            url(${PPMoriMedium3}) format('truetype'); /* Safari, Android, iOS */`,
                    },
                },
                {
                    "@font-face": {
                        fontFamily: "PPMoriSemibold",
                        fontStyle: "normal",
                        fontWeight: "normal",
                        src: `local('PPMoriSemibold'),
                            url(${PPMoriSemibold}) format('woff2'), /* Super Modern Browsers */
                            url(${PPMoriSemibold2}) format('woff'), /* Pretty Modern Browsers */
                            url(${PPMoriSemibold3}) format('truetype'); /* Safari, Android, iOS */`,
                    },
                },
                {
                    "@font-face": {
                        fontFamily: "PPMoriBold",
                        fontStyle: "normal",
                        fontWeight: "normal",
                        src: `local('PPMoriBold'),
                            url(${PPMoriBold}) format('woff2'), /* Super Modern Browsers */
                            url(${PPMoriBold2}) format('woff'), /* Pretty Modern Browsers */
                            url(${PPMoriBold3}) format('truetype'); /* Safari, Android, iOS */`,
                    },
                },
                // DM Sans
                {
                    "@font-face": {
                        fontFamily: "DMSans",
                        fontStyle: "normal",
                        fontWeight: "normal",
                        src: `local('DMSans'), url(${DMSans}) format('truetype');`,
                    },
                },
                {
                    "@font-face": {
                        fontFamily: "DMSansMedium",
                        fontStyle: "normal",
                        fontWeight: "normal",
                        src: `local('DMSansMedium'), url(${DMSansMedium}) format('truetype');`,
                    },
                },
                {
                    "@font-face": {
                        fontFamily: "DMSansBold",
                        fontStyle: "normal",
                        fontWeight: "normal",
                        src: `local('DMSansBold'), url(${DMSansBold}) format('truetype');`,
                    },
                },
            ])}
        />
    )
}
